import { useFormik } from "formik";
import { useTranslation } from "next-i18next";
import * as yup from "yup";
import { RequestedReasonData } from "./requested-reason-model";

/**
 * Manages form data for the requested portal step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useRequestedReasonFormik(
  onNext: (data: RequestedReasonData) => void
) {
  const { t } = useTranslation();
  const messageRequired = t("common:common.required");
  const requestreasonsNotEmpty = t(
    // "request_access:customer_access.customer_email_error"
    "you need to select at least one reason."
  );

  const validationSchema = yup.object().shape({
    showOther: yup.boolean(),
    requestReasons: yup
      .array()
      .of(
        yup.object().shape({
          reason: yup.string().required(),
          reasonEnglishKey: yup.string().required(),
          icon: yup.string(),
        })
      )
      .min(1, requestreasonsNotEmpty),

    otherReason: yup.string().when("showOther", {
      is: true,
      then: yup.string().required(messageRequired),
    }),
  });

  const formik = useFormik<RequestedReasonData>({
    initialValues: {
      requestReasons: [],
      otherReason: "",
      showOther: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
